// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1573":"67c2eef0","1821":"67c2eef0","2061":"67c2eef0","2088":"67c2eef0","2572":"e42daa22","4092":"8e32f4ad","5512":"f034aedd","7860":"3118f96d","9912":"67c2eef0"}[chunkId] + ".chunk.css";
};